import { useProperty, useTranslation } from '@eti/providers';
import { Accordion, Notification, variants } from '@eti/components';
import { css } from '@eti/styles';
import { Card, Stack, Text, textVariants, vars } from '@etg/wings';
import TopicsContentWrapper from '../TopicsContentWrapper';
import RefundStatus from '../../refund-status/RefundStatus';
import { shouldShowRefundStatusInformation } from '../../../utils';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import FaqSection from '../../common/FaqSection';

const accordionWrapperStyles = css`
  border: 1px solid #f0f0f0;
  border-radius: ${vars.button.borderRadius};
`;

const Refund = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { refundStatus, faqSectionPerSlug } = useOrderDetails();
  const faqSectionSlug = p('ContactUs.Refund.Faq.Slug');
  const hasRefund = shouldShowRefundStatusInformation(refundStatus);

  return (
    <TopicsContentWrapper
      chatType="oriana"
      leftColumnContent={
        <Stack spacing={24}>
          {hasRefund ? (
            <Stack spacing={24}>
              <Text>{t('ContactUs.Subtopic.RefundStatus.Requested.Description')}</Text>
              <Stack>
                <Text variant={textVariants._14_BOLD}>
                  {t('ContactUs.Subtopic.RefundStatus.Requested.Subheading.Text')}
                </Text>
                <Card className={accordionWrapperStyles}>
                  <Accordion id="refund-topic-accordion" spacing={16} variant="full-width">
                    <Accordion.Header data-testid="refund-status-accordion-button">
                      <Text variant={textVariants._14_BOLD}>
                        {t('MyBookings.RefundStatus.MultipleCases.Title')}
                      </Text>
                    </Accordion.Header>
                    <Accordion.Body>{refundStatus && <RefundStatus />}</Accordion.Body>
                  </Accordion>
                </Card>
              </Stack>
            </Stack>
          ) : (
            <Text>{t('ContactUs.Subtopic.RefundStatus.NotRequested.Content')}</Text>
          )}
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      rightColumnContent={
        hasRefund ? (
          <Notification
            dataTestId="refund-status-contact-us-notification"
            variant={variants.WARNING}
          >
            <Text>{t('ContactUs.Subtopic.RefundStatus.Requested.Notification.Content')}</Text>
          </Notification>
        ) : null
      }
      shouldShowContactMethods={!hasRefund}
      snowplowProperty="REFUND"
    />
  );
};

export default Refund;
